import repository from '@/repositories/repository'

export default baseUrl => {
    baseUrl = `${baseUrl}/websocket`

    return {
        login: async params => {
            return (await repository.post(`${baseUrl}/login`, params)).data
        }
    }
}